import * as THREE from 'three';
import { WardrobeModule } from '../modules/WardrobeModule';
import { BaseCabinet } from '../base/BaseCabinet';

export class WardrobeCabinet extends BaseCabinet {
  constructor(sceneManager) {
    super('wardrobe', sceneManager);
  }

  getConstraints() {
    return {
      groundOffset: 0,
      ceilingOffset: 0,

      typePriorities: {
        lower: 1,
        ceiling: 2,
      },

      typeHeights: {
        lower: 2100, // Tủ áo tiêu chuẩn (mm)
        ceiling: 900, // Phần đụng trần (mm)
      },
    };
  }

  getActiveMeshPoints(cloneModule) {
    // return this.getAllMeshPoints();
    return cloneModule?.getMeshPoints?.() || [];
  }

  /**
   * Implementation của abstract method từ BaseCabinet
   * Tạo KitchenModule instance
   */
  createModule(moduleData, moduleType, constraints) {
    return new WardrobeModule(
      moduleData,
      moduleType,
      this.sceneManager,
      this,
      constraints
    );
  }

  setActiveEditorModuleByUuid(uuid) {
    const module = this.getModuleByGroupUuid(uuid);
    if (module) {
      this.activeEditorModule = module;
      return true;
    }
    return false;
  }

  calculateModulePosition(moduleData, moduleType, index = null) {
    const constraints = this.constraints;
    const roomHeight = this.sceneManager.wallHeight * 1000;

    let yPosition = 0;

    switch (moduleType) {
      case 'lower':
        yPosition =
          constraints.groundOffset + constraints.typeHeights.lower / 2;
        break;

      case 'ceiling':
        yPosition =
          roomHeight -
          constraints.ceilingOffset -
          constraints.typeHeights.ceiling / 2;
        break;

      default:
        yPosition = 0;
    }

    // Tính vị trí X
    const existingModules = this.getModulesByType(moduleType);
    let xPosition = 0;

    if (existingModules.length > 0) {
      const lastModule = existingModules[existingModules.length - 1];
      const lastBox = new THREE.Box3().setFromObject(lastModule.module);
      const lastSize = new THREE.Vector3();
      lastBox.getSize(lastSize);

      xPosition =
        lastModule.module.position.x +
        (lastSize.x + (moduleData.width || 0.6)) / 2 +
        0.01;
    }

    return new THREE.Vector3(xPosition, yPosition / 1000, 0);
  }
}
